"use client";
import AcupressurePoints from "@/modules/Astro/Healing/AcupressurePoints";
import Aromatherapy from "@/modules/Astro/Healing/Aromatherapy";
import Ayurveda from "@/modules/Astro/Healing/Ayurveda";
import ColorTherapy from "@/modules/Astro/Healing/ColorTherapy";
import CrystalTherapy from "@/modules/Astro/Healing/CrystalTherapy";
import FengShui from "@/modules/Astro/Healing/FengShui";
import MedicalAstrology from "@/modules/Astro/Healing/MedicalAstrology";
import Meditation from "@/modules/Astro/Healing/Meditation";
import RelkiHealing from "@/modules/Astro/Healing/RelkiHealing";
import Yoga from "@/modules/Astro/Healing/Yoga";
import { usePathname } from "next/navigation";

const HealingPage = () => {
  const pathname = usePathname();
  const pathSegments = pathname.split("/").filter(Boolean);
  const subPage = pathSegments[pathSegments.length - 1];

  const renderModules = () => {
    if (!subPage || subPage.length === 0) {
      return <div>No modules to display. Please provide a valid path.</div>;
    } else if (subPage === "acupressure-points") {
      return <AcupressurePoints />;
    } else if (subPage === "aromatherapy") {
      return <Aromatherapy />;
    } else if (subPage === "ayurveda") {
      return <Ayurveda />;
    } else if (subPage === "color-therapy") {
      return <ColorTherapy />;
    } else if (subPage === "crystal-therapy") {
      return <CrystalTherapy />;
    } else if (subPage === "fengshui") {
      return <FengShui />;
    } else if (subPage === "medical-astrology") {
      return <MedicalAstrology />;
    } else if (subPage === "meditation") {
      return <Meditation />;
    } else if (subPage === "reiki-healing") {
      return <RelkiHealing />;
    } else if (subPage === "yoga") {
      return <Yoga />;
    }
  };

  return <div>{renderModules()}</div>;
};

export default HealingPage;
